import { Award, Phone, Mail } from 'styled-icons/feather';
import { Grid, Column, Paragraph } from '@bidalihq/ui';
import Link from 'next/link';
import tw from 'tailwind-styled-components';

import Section from '@/components/section';
import SocialMediaProfiles from '@/components/social-media-profiles';

const SmallTitle = tw.h3`
  text-2xl
  font-normal
`;

const ContactList = tw.div`
  flex
  items-start
`;

const IconContainer = tw.div`
  bg-white
  rounded-full
  shadow-md
  flex-shrink-0
  flex-grow-0
  mr-6
  p-4
`;

const ContactContent = tw.div``;

const ContactTitle = tw.h3`
  text-2xl
  font-normal
  mt-2
  mb-4
`;

const ContactInfo = () => {
  return (
    <Section className="lg:pt-0 pt-0">
      <Grid columns={[1, 2]}>
        <Column>
          <SmallTitle>Join us on Social Media</SmallTitle>
          <SocialMediaProfiles
            className="items-center !justify-start mt-5"
            angelList="https://angel.co/bidali"
            facebook="https://www.facebook.com/bidalihq"
            linkedin="https://www.linkedin.com/company/bidali"
            medium="https://medium.com/bidali"
            twitter="https://twitter.com/bidalihq" />
        </Column>
        <Column>
          <SmallTitle>General Communication</SmallTitle>
          <Paragraph>
            For general inquiries, partnership opportunites, or if you just want to say 👋, please email <Link href="mailto:hello@bidali.com">hello@bidali.com</Link>
          </Paragraph>
        </Column>
      </Grid>
      <Grid className="mt-24" columns={[1, 3]}>
        <Column>
          <ContactList>
            <IconContainer><Award className="block" size={24} strokeWidth={2} /></IconContainer>
            <ContactContent>
              <ContactTitle>Security & Compliance</ContactTitle>
              <Paragraph><Link href="mailto:security@bidali.com">security@bidali.com</Link></Paragraph>
              <Paragraph><Link href="mailto:legal@bidali.com">legal@bidali.com</Link></Paragraph>
              <Paragraph><Link href="mailto:compliance@bidali.com">compliance@bidali.com</Link></Paragraph>
            </ContactContent>
          </ContactList>
        </Column>
        <Column>
          <ContactList>
            <IconContainer><Phone className="block" size={24} strokeWidth={2} /></IconContainer>
            <ContactContent>
              <ContactTitle>Telephone</ContactTitle>
              <Paragraph>+1 (866) 302-4084</Paragraph>
            </ContactContent>
          </ContactList>
        </Column>
        <Column>
          <ContactList>
            <IconContainer><Mail className="block" size={24} strokeWidth={2} /></IconContainer>
            <ContactContent>
              <ContactTitle>Mailing Address</ContactTitle>
              <Paragraph>#300 - 1550 5 St SW<br />Calgary, AB, Canada, T2R 1K3</Paragraph>
            </ContactContent>
          </ContactList>
        </Column>
      </Grid>
    </Section>
  );
};

export default ContactInfo;
